import AaSequence from 'molbio/aa-sequences/AaSequence';
import {PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

class AaSequenceAnnotationsTableTabState extends PolymerTabState<AaSequence> {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Annotations',
    };
  }
}

export default AaSequenceAnnotationsTableTabState;
